/**
 * Brand identity constants for the platform
 */
export const BRAND_NAME = 'MXPatfan';
export const BRAND_NAME_FULL = 'MXPatfan';
export const BRAND_TAGLINE = 'Support creators, unlock exclusive content';

// Legacy name for backward compatibility
export const LEGACY_BRAND_NAME = 'Patreon';
